var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-4';
import { Option } from './Option';
import { NoMatch } from './NoMatch';
var isItemSelected = function (isEqual, item, selectedItems) { return !!(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.some(function (selected) { return isEqual(item, selected); })); };
export function Results(_a) {
    var noMatch = _a.noMatch, listToRender = _a.listToRender, noMatchMessageId = _a.noMatchMessageId, OptionBody = _a.OptionBody, refs = _a.refs, highlightedIndex = _a.highlightedIndex, dropdownAttributes = _a.dropdownAttributes, locale = _a.locale, onChange = _a.onChange, selectedItems = _a.selectedItems, isEqual = _a.isEqual;
    return (React.createElement(Scrollbars, { autoHeight: true, autoHeightMax: 335 },
        noMatch && (React.createElement(NoMatch, { noMatch: noMatch, noMatchMessageId: noMatchMessageId, listToRender: listToRender, locale: locale })),
        listToRender.map(function (item, index) {
            return (React.createElement(Option, { isSelected: isItemSelected(isEqual, item, selectedItems), key: Object.values(item).join('-'), ref: refs[index], isHighlighted: highlightedIndex === index, onClick: function () {
                    onChange(item);
                }, item: item }, function (props) { return (React.createElement(OptionBody, __assign({}, props, { locale: locale, dropdownAttributes: dropdownAttributes }))); }));
        })));
}
